var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_279",
    "data-name": "\\uADF8\\uB8F9 279",
    transform: "translate(-1028 -335)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 32,
    height: 32,
    transform: "translate(1028 335)",
    fill: "#ff2727",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M10,.563a10,10,0,1,0,10,10A10,10,0,0,0,10,.563Zm0,3.871A3.548,3.548,0,1,1,6.452,7.982,3.548,3.548,0,0,1,10,4.433ZM10,18.3a7.727,7.727,0,0,1-5.907-2.75,4.5,4.5,0,0,1,3.972-2.411.987.987,0,0,1,.286.044A5.339,5.339,0,0,0,10,13.466a5.319,5.319,0,0,0,1.649-.278.987.987,0,0,1,.286-.044,4.5,4.5,0,0,1,3.972,2.411A7.727,7.727,0,0,1,10,18.3Z",
    transform: "translate(1034 340.438)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d39d955b87011d347c9f7ee072005a0c.svg";
export { ForwardRef as ReactComponent };